// 为 tdesign-miniprogram 提供 Web 端兼容
// 这个 file 必须在 app.mpx 之前加载

// Fix for vue-i18n and other libraries trying to read Vue.version
// This MUST run before any Vue code loads
(function () {
  if (typeof window === 'undefined') return;

  const DEFAULT_VERSION = '2.7.16';

  function patchVueObject(v) {
    if (v && typeof v === 'object' && !v.version) {
      try {
        Object.defineProperty(v, 'version', {
          value: DEFAULT_VERSION,
          writable: true,
          configurable: true,
          enumerable: true
        });
      } catch (e) {
        v.version = DEFAULT_VERSION;
      }
    }
  }

  // Strategy 1: Intercept Vue assignment on window
  let _Vue = window.Vue;
  if (_Vue) patchVueObject(_Vue);

  Object.defineProperty(window, 'Vue', {
    get() { return _Vue; },
    set(value) {
      patchVueObject(value);
      _Vue = value;
    },
    configurable: true,
    enumerable: true
  });

  console.log('[Polyfill] Vue.version monitor installed');
})();

if (typeof window !== 'undefined') {
  // 确保 wx 对象存在
  if (!window.wx) {
    window.wx = {}
  }

  // 添加 getAppBaseInfo polyfill
  if (!window.wx.getAppBaseInfo) {
    window.wx.getAppBaseInfo = function () {
      return {
        SDKVersion: '3.0.0',
        version: '3.0.0',
        language: 'zh-CN',
        enableDebug: false,
        host: { appId: '', env: '' }
      }
    }
  }

  const DEFAULT_SDK_VERSION = '3.0.0';

  const mockSystemInfo = {
    SDKVersion: '3.0.0',
    version: '3.0.0',
    system: 'web',
    platform: 'web',
    statusBarHeight: 0,
    windowWidth: window.innerWidth || 375,
    windowHeight: window.innerHeight || 667,
    pixelRatio: window.devicePixelRatio || 2,
    screenHeight: window.screen.height || 667,
    screenWidth: window.screen.width || 375,
    safeArea: {
      top: 0,
      left: 0,
      right: window.innerWidth || 375,
      bottom: window.innerHeight || 667,
      width: window.innerWidth || 375,
      height: window.innerHeight || 667
    }
  }

  // 添加 getSystemInfoSync polyfill
  if (!window.wx.getSystemInfoSync) {
    window.wx.getSystemInfoSync = function () {
      const info = { ...mockSystemInfo };
      if (!info.SDKVersion) info.SDKVersion = DEFAULT_SDK_VERSION;
      return info;
    }
  } else {
    // 包装现有的以确保 SDKVersion
    const originalGetSystemInfoSync = window.wx.getSystemInfoSync;
    window.wx.getSystemInfoSync = function () {
      const info = originalGetSystemInfoSync();
      if (info && !info.SDKVersion) info.SDKVersion = DEFAULT_SDK_VERSION;
      return info;
    }
  }

  // 添加 getSystemInfo polyfill (异步版本)
  if (!window.wx.getSystemInfo) {
    window.wx.getSystemInfo = function (options) {
      if (options && options.success) {
        options.success(mockSystemInfo)
      }
      return Promise.resolve(mockSystemInfo)
    }
  }

  // 添加 getMenuButtonBoundingClientRect polyfill
  if (!window.wx.getMenuButtonBoundingClientRect) {
    window.wx.getMenuButtonBoundingClientRect = function () {
      return {
        bottom: 80,
        height: 32,
        left: (window.innerWidth || 375) - 88,
        right: (window.innerWidth || 375) - 7,
        top: 48,
        width: 81
      }
    }
  }

  // 添加 Storage polyfill
  if (!window.wx.getStorageSync) {
    window.wx.getStorageSync = function (key) {
      try {
        const val = localStorage.getItem(key)
        return val ? JSON.parse(val) : ''
      } catch (e) {
        return localStorage.getItem(key) || ''
      }
    }
  }
  if (!window.wx.setStorageSync) {
    window.wx.setStorageSync = function (key, val) {
      try {
        localStorage.setItem(key, typeof val === 'string' ? val : JSON.stringify(val))
      } catch (e) {
        console.error('[Polyfill] setStorageSync failed', e)
      }
    }
  }

  // 添加 getRelationNodes polyfill (tdesign-miniprogram 需要)
  if (!window.wx.getRelationNodes) {
    window.wx.getRelationNodes = function () {
      return []
    }
  }

  // 添加 setClipboardData polyfill
  if (!window.wx.setClipboardData) {
    window.wx.setClipboardData = function (options) {
      const data = options.data || ''
      return new Promise((resolve, reject) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(data).then(() => {
            if (options.success) options.success({ errMsg: 'setClipboardData:ok' })
            resolve({ errMsg: 'setClipboardData:ok' })
          }).catch(err => {
            if (options.fail) options.fail(err)
            reject(err)
          })
        } else {
          // Fallback
          const textArea = document.createElement('textarea')
          textArea.value = data
          textArea.style.position = 'fixed'
          textArea.style.left = '-9999px'
          document.body.appendChild(textArea)
          textArea.select()
          try {
            document.execCommand('copy')
            if (options.success) options.success({ errMsg: 'setClipboardData:ok' })
            resolve({ errMsg: 'setClipboardData:ok' })
          } catch (err) {
            if (options.fail) options.fail(err)
            reject(err)
          } finally {
            document.body.removeChild(textArea)
          }
        }
      })
    }
  }

  console.log('[Polyfill] Enhanced wx API polyfills installed (with Storage & Clipboard)')
}
